import { ReceiptType } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { LocalizedDateTimeFromUtc } from '@mews-commander/ui';
import { LocalizedEnum } from '@mews/framework';
import { Stack, Tag, Typography } from '@optimus-web/core';
import { usePaymentDetailsSidebarContext } from '../context/PaymentDetailsSidebarContext';
import { paymentStatusToTagVariantMap } from '../utils';
import { PaymentDetailsSidebarGrid } from './PaymentDetailsSidebarGrid';
import { PaymentDetailsSidebarRow, PaymentDetailsSidebarRowTypography } from './PaymentDetailsSidebarRow';

export const TransactionDetailsSection = () => {
    const { paymentDetails, receipt } = usePaymentDetailsSidebarContext();

    if (!paymentDetails) {
        return null;
    }

    const { status, createdUtc, title, creatorProfileName } = paymentDetails;

    const isTerminalPayment = !!receipt?.receiptData;

    const identifier =
        receipt?.receiptData?.discriminator === ReceiptType.StripeReceipt
            ? receipt?.receiptData?.value?.identifier
            : undefined;

    return (
        <PaymentDetailsSidebarGrid>
            <PaymentDetailsSidebarRow labelTextKey={TextKey.Status}>
                <Tag variant={paymentStatusToTagVariantMap[status]}>
                    <LocalizedEnum prefix="PaymentState" value={status} />
                </Tag>
            </PaymentDetailsSidebarRow>

            <PaymentDetailsSidebarRowTypography labelTextKey={TextKey.Type} value={title} />

            <PaymentDetailsSidebarRow labelTextKey={TextKey.Created}>
                <Stack vertical>
                    {createdUtc && (
                        <Typography textStyle="bodyMediumStrong" as="div">
                            <LocalizedDateTimeFromUtc utcString={createdUtc} />
                        </Typography>
                    )}
                    {creatorProfileName && (
                        <Typography textStyle="bodyMediumStrong" as="div">
                            {creatorProfileName}
                        </Typography>
                    )}
                </Stack>
            </PaymentDetailsSidebarRow>
            {isTerminalPayment && identifier && (
                <PaymentDetailsSidebarRowTypography labelTextKey={TextKey.Identifier} value={identifier} />
            )}
            {isTerminalPayment && (
                <PaymentDetailsSidebarRowTypography
                    labelTextKey={TextKey.PaymentDetailSidebarPaymentChannel}
                    value={TextKey.Terminal}
                />
            )}
        </PaymentDetailsSidebarGrid>
    );
};
